// Exports
export default {
	"container": "container_Wtuk0",
	"header": "header_c9su2",
	"button": "button_oGy0s",
	"shareScreenIcon": "shareScreenIcon_ZdIZg",
	"loader": "loader_VwZpO"
};
